
import { Vue } from 'vue-class-component';

export default class Tooltip extends Vue {
    isOpen = false;
}
